export default "__VITE_ASSET__ChXnTYcC__"